<template>
	<section class="form form__vertical">
		<div class="form__heading">
			<h1 class="heading-title">Chyba :(</h1>
			<h2 class="content-default">{{ text }}</h2>
		</div>
		<div class="terms__controls">
			<v-button nativeType="button" class="spacer_bottom-125" @click="$emit('close')">okay :((((((</v-button>
		</div>
	</section>
</template>

<script>
export default {
	props: {
		text: {
			type: String,
			required: true,
			default: 'něco se pokazilo... zkus to prosím později.',
		},
	},
}
</script>
